import { render, staticRenderFns } from "./FeaturesMobileView.vue?vue&type=template&id=53505756&scoped=true"
import script from "./FeaturesMobileView.vue?vue&type=script&lang=js"
export * from "./FeaturesMobileView.vue?vue&type=script&lang=js"
import style0 from "./FeaturesMobileView.vue?vue&type=style&index=0&id=53505756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53505756",
  null
  
)

export default component.exports